import React, { useRef } from 'react'
import { useValue } from '../../context/ContextProvider'
import { Avatar, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, TextField } from '@mui/material';
import { Close, Send } from '@mui/icons-material';
import { updateProfile } from '../../actions/user';

const Profile = () => {

    const { state: { profile, currentUser }, dispatch } = useValue();
        
    const nameRef = useRef();

    const handleClose = () => {
        dispatch({ type: 'UPDATE_PROFILE', payload: { ...profile, open: false } });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        const name = nameRef.current.value;
        updateProfile(currentUser, {name, file: profile.file}, dispatch);
    }

    const handleChange = (e) => {
        const file = e.target.files[0];
        if(file) {
            const photoURL = URL.createObjectURL(file);
            //console.log(photoURL);
            dispatch({ type: 'UPDATE_PROFILE', payload: {...profile, file, photoURL}});
        }
    }

    return (
        <Dialog open={profile.open} onClose={handleClose} >
            <DialogTitle>
                Perfil del Usuario
                <IconButton
                    sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                    onClick={handleClose}
                >
                    <Close />
                </IconButton>
            </DialogTitle>
            <form onSubmit={handleSubmit}>
                <DialogContent dividers>
                    <DialogContentText>
                        Puede actualiza su información mediante los siguiente campos:
                    </DialogContentText>

                    <TextField
                        autoFocus
                        margin='normal'
                        variant='standard'
                        id='name'
                        label='Nombre'
                        type='text'
                        fullWidth
                        inputRef={nameRef}
                        inputProps={{ minLength: 2 }}
                        required
                        defaultValue={currentUser?.name}
                    />

                    <label htmlFor='profilePhoto'>
                        <input
                            accept='image/*'
                            id='profilePhoto'
                            type='file'
                            style={{ display: 'none' }}
                            onChange={handleChange}
                        />
                            <Avatar
                                src={profile.photoURL}
                                sx={{height: '120px', width: '120px', cursor: 'pointer'}}
                            />
                    </label>

                </DialogContent>
                <DialogActions sx={{ pr: '22px', pt: '20px' }}>
                    <Button type='submit' variant='contained' endIcon={<Send />}>
                        Actualizar
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    )
}

export default Profile